import React from 'react'

const Footer = () => {
  return (
    <div className=''>
    <div className="flex justify-center border-t border-b mt-8">
    © 2023 by $JACK.
    </div>
  </div>
  )
}

export default Footer